import { render, staticRenderFns } from "./BotaoCompartilhamentoDados.vue?vue&type=template&id=0d75c9ec&lang=pug"
import script from "./BotaoCompartilhamentoDados.vue?vue&type=script&lang=js"
export * from "./BotaoCompartilhamentoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports